import Box from "@mui/material/Box";
import Grid from "components/primitives/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Group } from "contexts/GroupsContext/GroupsContext";
import NotePadIcon from "components/IconsStandardized/NotePadIcon/NotePadIcon";
import Mui5 from "components/mui5";
import { useNavigate } from "react-router-dom";
import Constants from "config/Constants";
import * as Components from "./GroupTitle.components";
import { useTranslation } from "react-i18next";

interface GroupTitleProps extends Group {
  activeCount: number;
}

function GroupTitle(props: GroupTitleProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Components.ColorBlockGrid bgcolor={props.colour} />
      <Grid size="grow" container sx={{ alignItems: "center", width: "100%" }}>
        <Grid>
          <Typography variant="h2" gutterBottom sx={{ display: "flex", alignItems: "center" }}>
            <Box component="span" sx={{ fontWeight: "fontWeightMedium" }}>
              {props.name}
            </Box>
            <Box component="span" sx={{ px: 2 }}>
              <IconButton
                onClick={() => navigate(`${Constants.routes.groups.route}/${props.id}/edit`)}
                size="small"
                color="primary"
                aria-label={t("global.edit_group_aria_label")}
              >
                <NotePadIcon fontSize="small" />
              </IconButton>
            </Box>
          </Typography>
          <Typography variant="h4">{t("group.overview.athletes_count", { count: props.activeCount })}</Typography>
        </Grid>
        <Grid size="grow" />
        <Grid>
          <Mui5.Button sx={{ width: 320 }} href={`/charting?sourceId=${props.id}`}>
            {t("group.overview.chart_group_button_text")}
          </Mui5.Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default GroupTitle;
